import { z } from "zod";

export const SchemaRecoverPassword = z.object({
  email: z.string().email("Digite um e-mail válido.").trim(),
});
